import { get } from 'lodash';

export const selectors = {
  carriers: state => get(state, 'shipping.options'),
};
